import { useContext, useEffect, useState } from 'react';
import LayersContext from '../context/LayersContext';
import { formatValue } from '../utils/helpers';

interface LayerSummaryProps {
    dashboardView: string;
}

const LayerSummary: React.FC<LayerSummaryProps> = ({ dashboardView }) => {
    const { layers } = useContext(LayersContext);
    const [activeLayer, setActiveLayer] = useState<string | null>(null);

    // Get the layer items from the active layer
    const activeLayerData = layers?.find(layer => layer.layer_name === activeLayer);
    const layerItems = activeLayerData?.items || [];

    console.log(' layers:', layers);
    console.log('dashboard view:',dashboardView)

    console.log('active layer:', activeLayer)

    useEffect(() => {
        if (!activeLayer && layers.length > 0) {
            const layer = layers.find(layer => layer.layer_id_ext === dashboardView);
            if (layer) {
                setActiveLayer(layer.layer_name);
            } else setActiveLayer(null)
        }
    }, [layers])

    // Set the active layer based on dashboardView prop
    // const activeLayer = layers.find(layer => layer.layer_id_ext === dashboardView) || null;

    // Sort the filtered items by activity_date (descending)
    const sortedLayerItems = layerItems?.sort((a, b) => {
        const dateA = new Date(a.activity_date);
        const dateB = new Date(b.activity_date);
        return dateB.getTime() - dateA.getTime();
    });

    // Calculate the total value of the filtered items
    const totalValue = sortedLayerItems?.reduce((sum, item) => sum + (item.value || 0), 0) || 0;

    // Paginate the filtered items
    const totalItems = sortedLayerItems?.length || 0;

    console.log('total layer items:', sortedLayerItems);

    // Get category counts
    const categoryCounts = layerItems?.reduce((acc, item) => {
        if (item.category) {
            acc[item.category] = (acc[item.category] || 0) + 1;
        }
        return acc;
    }, {} as Record<string, number>) || {};

    const categories = Object.entries(categoryCounts);

    return (
        <div>
            {/* Message when no active layer is selected */}
            {!activeLayerData ? (
                <div className="mt-4 p-4 text-center text-gray-600">
                    <p>No active layer selected.</p>
                </div>
            ) : (
                <>
                    {/* Header */}
                    <div className='flex items-center justify-center bg-[#EFEFEF] h-12'>
                        <p className='text-sm font-bold text-port-text'>{activeLayer}</p>
                    </div>
                    {/* Totals */}
                    <div className="flex flex-col items-center justify-center border-b-2 mx-8">
                        <div className='flex items-baseline justify-center space-x-2'>
                            <p className="text-[44px] font-bold text-port-blue font-barlow-condensed">
                                {formatValue(totalItems, 'integer')}
                            </p>
                            <p className='text-sm font-bold text-port-text'>Total Locations</p>
                        </div>

                        {totalValue ? 
                            <div className={`flex flex-col items-center justify-center`}>
                                <p className="text-[44px] font-bold text-port-blue font-barlow-condensed">
                                    ${formatValue(totalValue, 'integer')}
                                </p>
                                <p className='text-sm font-bold text-port-text'>Total Funding</p>
                            </div> 
                            :
                            null
                        }
                    </div>
                    <div className="grid grid-cols-2 p-6 pt-0 w-full">
                        {/* Category Count */}
                        <div className="mt-4 grid grid-cols-2 col-span-2 justify-center">
                            {categories.length > 0 ? (
                                categories.map(([category, count]) => (
                                    <div key={category} className="p-2">
                                        <div className="flex flex-col items-center space-x-2 border-slate-100 bg-slate-100 rounded-md shadow-lg">
                                            <span className="font-semibold text-sm">{category}</span>
                                            <span className="text-4xl text-port-blue font-bold">
                                                {count}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="flex justify-center space-x-2">
                                    <span className="font-semibold text-sm">
                                        Category summary not available.
                                    </span>
                                </div>
                            )}
                        </div>

                        
                    </div>
                </>
            )}
        </div>
    );
};

export default LayerSummary;